import React, { Component } from 'react';
import {
  FormGroup,
  Input,
  Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';
import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AddIcon } from '../icon/AddIcon';
import { RemoveIcon } from '../table/RemoveIcon';
import { fieldToNumber, fieldTrimmed } from './formUtilities';
import { Column } from '../grid/Column';
import { Loading } from '../loadbar/Loading';
import { ResultGrid } from '../grid/ResultGrid';
import { RawHtml } from './RawHtml';
import {
  minColumns,
  refSort,
  refVisibleColumns,
} from '../../redux/EditReduxConstant';

const resolvePublish = ({ value }) => {
  if (value == null) {
    return null;
  }
  return value ? 'Y' : 'N';
};


const resolveId = (cellInfo) => {
  const { value: id, index } = cellInfo;
  if (id == null) {
    return null;
  }
  return (
    <div>
      {id}
      <Control
        type="hidden"
        model={`.referenceIds[${index}]`}
        mapProps={{
          tabIndex: '-1',
          className: ({ fieldValue }) => classnames({ 'form-control': true, 'sr-only': true, 'is-invalid': !fieldValue.valid }),
        }}
      />
      <Errors
        model={`.referenceIds[${index}]`}
        component="div"
        wrapper={({ children }) => <div className="invalid-feedback">{children}</div>}
      />
    </div>
  );
};

class AssociatedReferenceControlUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.searchReferences = this.searchReferences.bind(this);
    this.addReference = this.addReference.bind(this);
    this.removeReference = this.removeReference.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.resolveRemove = this.resolveRemove.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.state = {
      references: Map(),
      initialReferenceIds: List(),
      searchVisible: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    const { initialReferences } = this.props;
    this.setState(({ references }) => {
      let initialReferenceIds = List();
      let updatedReferences = references;
      initialReferences.forEach((reference) => {
        updatedReferences = updatedReferences.set(`${reference.get('id')}`, reference);
        initialReferenceIds = initialReferenceIds.push(`${reference.get('id')}`);
      });
      return {
        references: updatedReferences,
        initialReferenceIds,
      };
    });
  }

  searchReferences() {
    const { searchReferences } = this.props;
    const { searchInput } = this.state;
    searchReferences({
      queryParameters: {
        op: 'or',
        citInclude: fieldTrimmed(searchInput),
        id: fieldToNumber(searchInput),
        authorInclude: fieldTrimmed(searchInput),
      },
    });
  }

  addReference(selectedRef) {
    const { change, model, formReferenceIds } = this.props;
    const id = selectedRef ? selectedRef.get('id') : '';
    this.setState((state) => {
      const references = state.references.set(`${id}`, selectedRef);
      return { references };
    }, () => {
      change(`${model}.referenceIds`, formReferenceIds.push(`${id}`));
    });
  }

  removeReference(id, index) {
    const { change, model, formReferenceIds } = this.props;
    const { initialReferenceIds } = this.state;
    change(`${model}.referenceIds`, formReferenceIds.delete(index));
    this.setState(({ references }) => {
      if (!initialReferenceIds.includes(id)) {
        references.delete(id);
      }
      return { references };
    });
  }

  resolveRemove({ row, index }) {
    if (row.get('id') == null) {
      return null;
    }
    return (<RemoveIcon handleClick={() => this.removeReference(row.get('id'), index)} />);
  }

  toggleSearch() {
    this.setState(({ searchVisible: prev }) => ({ searchVisible: !prev }));
  }

  renderAddButton({ row }) {
    const { formReferenceIds } = this.props;

    if (formReferenceIds.includes(`${row.get('id')}`)) {
      return (<div />);
    }

    return (<AddIcon handleClick={() => this.addReference(row)} />);
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  render() {
    const {
      referenceSearching, referenceSearchResults, valid, sort, formReferenceIds, visibleColumns,
    } = this.props;
    const { references, searchVisible } = this.state;
    return (
      <Card className="haz-assoc-ref">
        <CardBody>
          <CardTitle tag="h2">References</CardTitle>

          <div className="haz-assoc-ref-container">
            <ResultGrid data={formReferenceIds.filter(id => references.get(id)).map(id => references.get(id))}>
              <Column id="remove" cell={this.resolveRemove} width={50}><RemoveIcon /></Column>
              <Column id="id" cell={resolveId} width={100}>ID</Column>
              <Column id="publish" cell={resolvePublish} width={85}>Publish</Column>
              <Column id="author" width={150}>Author</Column>
              <Column id="year" width={120}>Year</Column>
              <Column id="citation" width={200} cell={({ value }) => (<RawHtml>{value}</RawHtml>)}>Citation</Column>
            </ResultGrid>
          </div>

          <Errors
            model=".referenceIds"
            component="div"
            wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
          />

          {searchVisible ? (
            <Card>
              <CardBody>
                <CardTitle tag="h2" className="haz-close-title">
                  <span>Search</span>
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleSearch}>x</button>
                </CardTitle>
                <div className="haz-assoc-search-container">
                  <div className="form-inline">
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                      <Input disabled={referenceSearching} onChange={(e) => { this.setState({ searchInput: e.target.value }); }} type="text" />
                    </FormGroup>
                    <Button disabled={referenceSearching} onClick={this.searchReferences}>Search</Button>
                  </div>

                  <div className="haz-assoc-search">
                    {referenceSearching ? (<Loading />) : (
                      <ResultGrid
                        data={referenceSearchResults}
                        sort={sort}
                        handleColumnsToggle={this.handleToggleColumns}
                        columnChooser
                        visibleColumns={visibleColumns}
                        defaultColumns={refVisibleColumns}
                        defaultSort={refSort}
                        minColumns={minColumns}
                      >
                        <Column id="add" width={50} alwaysVisible cell={this.renderAddButton}><AddIcon /></Column>
                        <Column id="id" width={100} sortable>ID</Column>
                        <Column id="publish" cell={resolvePublish} width={120} sortable>Publish</Column>
                        <Column id="author" width={200} sortable>Author</Column>
                        <Column id="year" width={150} sortable>Year</Column>
                        <Column id="citation" width={250} sortable cell={({ value }) => (<RawHtml>{value}</RawHtml>)}>Citation</Column>
                      </ResultGrid>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (<Button onClick={this.toggleSearch}>Search</Button>)}

        </CardBody>
      </Card>
    );
  }
}


AssociatedReferenceControlUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  searchReferences: PropTypes.func.isRequired,
  referenceSearching: PropTypes.bool.isRequired,
  referenceSearchResults: ImmutablePropTypes.list.isRequired,
  change: PropTypes.func.isRequired,
  formReferenceIds: ImmutablePropTypes.list.isRequired,
  initialReferences: ImmutablePropTypes.list.isRequired,
  valid: PropTypes.bool.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};


const mapStateToProps = (state, { model }) => ({
  formReferenceIds: state.getIn([model, 'referenceIds']),
  valid: state.get('forms')[model].referenceIds.$form.valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  change: actions.change,

}, dispatch);

export const AssociatedReferenceControl = connect(mapStateToProps, mapDispatchToProps)(AssociatedReferenceControlUnwrapped);
